export const freeUserTrackLimitMessage = 'Free users can only create a maximum of 2 tracks.'
export const freeUserShareMessage = 'Share to cloud is a subscriber only feature.'
export const freeUserDownloadMessage = 'Save to file is a subscriber only feature.'
export const freeUserEditSharedMessage = 'Editing a shared GPX is a subscriber only feature.'